import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Switcher.module.css';
import Icon from '../Icon';
import Skeleton from '../Skeleton';

const bindClasses = classNameBind.bind(styles);

const renderIcons = (checked, onHold) => {
  let iconName = '';
  if (checked) {
    iconName = onHold ? 'on-hold' : 'checkmark';
  } else {
    iconName = 'cross';
  }

  return (
    <Icon name={iconName} className={bindClasses('switcher-icon')} />
  );
};

const renderSkeleton = (size) => {
  let widthSize = '';
  let heightSize = '';

  if (size === 'small') {
    heightSize = 24;
    widthSize = 44;
  } else if (size === 'medium') {
    heightSize = 32;
    widthSize = 59;
  } else {
    heightSize = 40;
    widthSize = 74;
  }

  return (
    <Skeleton
      width={widthSize}
      height={heightSize}
      roundBorder
    />
  );
};

export default class Switcher extends React.Component {
  static defaultProps = {
    disabled: false,
    onChange: () => {},
    onBlur: () => {},
    autoFocus: false,
    dataId: 'Switcher',
    setRef: null,
    onHold: false,
    size: 'small',
    skeleton: false,
  }

  handleChange = () => {
    const {
      disabled,
      onChange,
      value,
      name,
    } = this.props;

    if (!disabled) {
      onChange({
        target: {
          name,
          value: !value,
        },
      });
    }
  }

  handleBlur = () => {
    const {
      disabled,
      onBlur,
      value,
      name,
    } = this.props;

    if (!disabled) {
      onBlur({
        target: {
          name,
          value,
        },
      });
    }
  }

  render() {
    const {
      id,
      disabled,
      value,
      name,
      autoFocus,
      dataId,
      setRef,
      onHold,
      size,
      skeleton,
    } = this.props;

    if (skeleton) return renderSkeleton(size);

    return (
      <div className={bindClasses('wrapper')} data-ppuc-id={dataId}>
        <input
          id={id}
          type="checkbox"
          name={name}
          onChange={this.handleChange}
          disabled={disabled}
          value={value}
          tabIndex={0}
          className={bindClasses('switcher-checkbox')}
          data-ppuc-id={`${dataId}.value`}
          autoFocus={autoFocus}
        />
        <div
          className={bindClasses('background', size, { checked: value, onHold, disabled })}
          onClick={this.handleChange}
          onBlur={this.handleBlur}
          role="button"
          tabIndex={-1}
          ref={setRef}
        >
          <div className={bindClasses('switch', size, { checked: value, onHold })}>
            {renderIcons(value, onHold)}
          </div>
        </div>
      </div>
    );
  }
}
